import { ref, onMounted, onUnmounted, Ref } from 'vue'

export interface DeviceDimensions {
  windowWidth: Ref<number>
}

export function useWindowSize(): DeviceDimensions {
  const windowWidth = ref(0)

  const updateWidth = (): void => {
    windowWidth.value = window.innerWidth
  }

  onMounted(() => {
    // Set initial width
    updateWidth()

    // Add event listener for window resize
    window.addEventListener('resize', updateWidth)
  })

  onUnmounted(() => {
    // Clean up event listener
    window.removeEventListener('resize', updateWidth)
  })

  return {
    windowWidth,
  }
}
